import { useState, SyntheticEvent } from 'react';
import { Box, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { DrawerHeader, PinDrawer } from '@components/drawerItem/DrawerHeader';
import { Tabs } from '@components/tabs';
import { scrollbarStyle } from '@theme/styles';
import { QuoteDrawerUrlParams } from '@pages/QuoteDetails/constants/drawerListItems';
import { PolicyTab } from './tabs/PolicyTab';
import { CustomerTab } from './tabs/CustomerTab';
import { RelatedTransactionsTab } from './types';
import { TAB_CONFIG } from './utils/constants';

interface RelatedTransactionsProps {
  isFullScreen?: boolean;
}

export const RelatedTransactions = ({ isFullScreen = false }: RelatedTransactionsProps) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  // Determine initial tab from URL or default to Policy
  const searchParams = new URLSearchParams(search);
  const tabParam = searchParams.get('sidebarTab');
  const initialTab =
    tabParam === RelatedTransactionsTab.Customer ? RelatedTransactionsTab.Customer : RelatedTransactionsTab.Policy;

  const [activeTab, setActiveTab] = useState<RelatedTransactionsTab>(initialTab);

  const handleTabChange = (event: SyntheticEvent, newValue: RelatedTransactionsTab) => {
    setActiveTab(newValue);
    // Update URL with new tab
    const newSearchParams = new URLSearchParams(search);
    newSearchParams.set('sidebarTab', newValue);
    navigate(`?${newSearchParams.toString()}`, { replace: true });
  };

  const tabContent = (
    <>
      {activeTab === RelatedTransactionsTab.Policy && <PolicyTab />}
      {activeTab === RelatedTransactionsTab.Customer && <CustomerTab />}
    </>
  );

  const tabsComponent = (
    <Box sx={{ borderColor: 'divider', mt: 2, mb: '-9px' }}>
      <Tabs value={activeTab} type='miniShort' onChange={handleTabChange}>
        <Tab
          label={TAB_CONFIG[RelatedTransactionsTab.Policy].label}
          value={RelatedTransactionsTab.Policy}
          tabIndex={0}
        />
        <Tab
          label={TAB_CONFIG[RelatedTransactionsTab.Customer].label}
          value={RelatedTransactionsTab.Customer}
          tabIndex={0}
        />
      </Tabs>
    </Box>
  );

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <DrawerHeader drawerTitle='Related Transactions' padding='19px 16px 0px'>
        {!isFullScreen && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <PinDrawer urlParam={QuoteDrawerUrlParams.RelatedTransactions} />
          </Box>
        )}
        {tabsComponent}
      </DrawerHeader>

      <Box sx={{ overflowY: 'auto', flexGrow: 1, ...scrollbarStyle }}>{tabContent}</Box>
    </Box>
  );
};
